
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.488 21.724a3.775 3.775 0 11-7.55 0 3.775 3.775 0 017.55 0zM14.063 21.724a3.775 3.775 0 11-7.55 0 3.775 3.775 0 017.55 0zM23.5 27.387a9.44 9.44 0 00-8.765 5.932 9.412 9.412 0 00-.672 3.505V40.6h18.875v-3.776a9.412 9.412 0 00-.673-3.505 9.44 9.44 0 00-8.765-5.932z","fill":"#059669"}}),_c('path',{attrs:{"d":"M32.938 40.6h9.437v-3.776a5.663 5.663 0 00-10.11-3.505m.673 7.28H14.063m18.875 0v-3.775a9.412 9.412 0 00-.673-3.505M14.063 40.6H4.625v-3.775a5.663 5.663 0 0110.11-3.505m-.672 7.28v-3.775c0-1.238.238-2.421.672-3.505m0 0a9.44 9.44 0 018.765-5.932 9.44 9.44 0 018.765 5.932m8.223-11.595a3.775 3.775 0 11-7.55 0 3.775 3.775 0 017.55 0zm-26.425 0a3.775 3.775 0 11-7.55 0 3.775 3.775 0 017.55 0z","stroke":"#059669","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M23.5 27.387a9.44 9.44 0 00-8.765 5.932 9.411 9.411 0 00-.672 3.505V40.6h18.875v-3.775a9.411 9.411 0 00-.673-3.505 9.44 9.44 0 00-8.765-5.932z","fill":"#059669","stroke":"#059669","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.5 23.575a7.514 7.514 0 100-15.028 7.514 7.514 0 000 15.028zm1-11.088a1 1 0 10-2 0v2.574h-2.574a1 1 0 000 2h2.575v2.575a1 1 0 102 0v-2.575h2.574a1 1 0 100-2h-2.574v-2.575z","fill":"#059669"}})])
          )
        }
      }
    